import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../dashboardContent/config";
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import jsPDF from "jspdf";
import "../../StylesCSS/EtudiantsInterieurVille.css";
import "jspdf-autotable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const TableA = ({ setActiveSection }) => {
  const { userId } = useUser();
  const [institutions, setInstitutions] = useState([]);
  const [selectedInstitution, setSelectedInstitution] = useState("");
  const [selectedInstitution1, setSelectedInstitution1] = useState("");

  const [selectedAnneeScolaire, setSelectedAnneeScolaire] = useState("");
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [students, setStudents] = useState([]);
  const [currentStudentIndex, setCurrentStudentIndex] = useState(0);
  const [excelFileId, setExcelFileId] = useState(null);
  const [seuil, setSeuil] = useState(0);
  const [nextClicked, setNextClicked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleGoBack = (section) => {
    setActiveSection(section);
    console.log("Retour");
  };

  const [studentsParClasse, setStudentsParClasse] = useState({});

  useEffect(() => {
    if (selectedInstitution) {
      getEtudiants(selectedInstitution)
        .then((data) => {
          setStudentsParClasse(data);
          console.log("Données étudiantes par classe:", data);
        })
        .catch((err) => console.error(err));
    }
  }, [selectedInstitution]);

  // Récupérer les institutions
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/version3/api/excel/institutions/${userId}`)
      .then((response) => setInstitutions(response.data))
      .catch((error) =>
        console.error("Erreur lors de la récupération des institutions:", error)
      );
  }, [userId]);

  const getEtudiants = async (selectedInstitution) => {
  const response = await fetch(
    `${API_BASE_URL}/version3/api/excel/students?institution=${selectedInstitution}&userId=${userId}`
  );
  const data = await response.json();
  return data; // retourne un objet { filles: x, garcons: y }
};
  getEtudiants(selectedInstitution).then((data) => {
    console.log("Résultat brut :", data);

    // Afficher chaque classe et sa liste d'étudiants
    Object.entries(data).forEach(([classe, etudiants]) => {
      console.log(`Classe : ${classe}`);
      console.table(etudiants); // Affiche les étudiants en tableau dans la console
    });
  });

  const getFilteredStudents = async (selectedInstitution1) => {
    try {
      console.log("Selected Institution:", selectedInstitution1);
      console.log("User ID:", userId); // Afficher l'userId dans la console pour débogage

      const response = await axios.get(
        `${API_BASE_URL}/version3/api/students/getStudentsExclus`,
        {
          params: {
            selectedInstitution1: selectedInstitution1,
            userId: userId,
          },
        }
      );

      console.log("Données des étudiants filtrés:", response.data); // Afficher les données dans la console
      return response.data; // Retourner les données des étudiants filtrés
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des étudiants filtrés:",
        error
      );
      return [];
    }
  };

  // Appel à l’API pour récupérer les établissements d’accueil
const fetchHostInstitutions = async () => {
  const response = await fetch(`${API_BASE_URL}/version3/api/excel/with-host-institution`);
  const data = await response.json();

  // Création d’une map classe => hostInstitution
  const hostInstitutionMap = {};
  data.forEach(item => {
    if (item.classe && item.hostInstitutions?.length > 0) {
      hostInstitutionMap[item.classe] = item.hostInstitutions[0]; // on prend le 1er établissement
    }
  });

  return hostInstitutionMap;
};

  const [directions, setDirections] = useState({ direction_provinciale: '', direction_regionale: '' });
  const [loading, setLoading] = useState(true);


   useEffect(() => {
    if (userId) {
      axios.get(`${API_BASE_URL}/api/forms/directions/${userId}`)
        .then(response => {
          console.log('Direction provinciale :', response.data.direction_provinciale);
          console.log('Direction régionale :', response.data.direction_regionale);
          setDirections(response.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Erreur lors du chargement des directions:', error);
          setLoading(false);
        });
    }
  }, [userId]);

  const handleExportPDF = async () => {
    if (!selectedInstitution) {
      alert("Veuillez sélectionner une institution !");
      return;
    }
      const hostInstitutionMap = await fetchHostInstitutions();

    // Appel API avec l'institution sélectionnée
    const studentsByClass = await getEtudiants(selectedInstitution);

    // Aplatir les données pour avoir un tableau d'étudiants avec la classe
    const allStudents = Object.entries(studentsByClass).flatMap(
      ([classe, students]) =>
        students.map((student) => ({
          ...student,
          classe, // ajouter la classe dans chaque objet étudiant
        }))
    );

    console.log("allStudents", allStudents);

    // Préparer les données pour le tableau
    /*  const studentTableData = allStudents.map((student, index) => ({
    num: index + 1,
    classe: student.classe,
    nature: student.nature,
    deux_an_avant: student.deux_an_avant,
    un_an_avant: student.un_an_avant,
    niveauActuel: student.niveauActuel,
    numeroEleve: student.numeroEleve,
    nomEtPrenom: student.nomEtPrenom,
  })); */

    // Construire les données pour le tableau dans le PDF
    const studentTableData = allStudents.map((student, index) => ({
      num: index + 1,
      classe: student.classe,
      nomEtPrenom: student.nomEtPrenom,
      numeroEleve: student.numeroEleve,
      nature: student.nature,
      niveauActuel: student.niveauActuel,
      un_an_avant: student.un_an_avant,
      deux_an_avant: student.deux_an_avant,
      noteTotal: student.noteTotal,
      decisionConseil: student.decisionConseil || "-", // afficher '-' si vide
      deuxiemeLangueEtrangere: student.deuxiemeLangueEtrangere || "-",
      
    }));

    console.log("table students", studentTableData);

    // Grouper par classe pour générer une page par classe
    const groupedByClass = studentTableData.reduce((acc, student) => {
      if (!acc[student.classe]) acc[student.classe] = [];
      acc[student.classe].push(student);
      return acc;
    }, {});

    const doc = new jsPDF("p", "pt", "a4");

    // Ajouter la police arabe
    doc.addFont(
      "/fonts/NotoSansArabic-Regular.ttf",
      "NotoSansArabic",
      "normal"
    );
    doc.setFont("NotoSansArabic");
    doc.setFontSize(12);

    // Charger l'image (logo)
    const img = new Image();
    img.src = "/images/Photo1.PNG";
    await new Promise((resolve) => {
      img.onload = resolve;
    });

    const imgWidth = 250;
    const imgHeight = (img.height * imgWidth) / img.width;

    Object.entries(groupedByClass).forEach(([classe, students], index) => {
      if (index > 0) doc.addPage();

      // Ajouter le logo centré
      doc.addImage(
        img,
        "PNG",
        (doc.internal.pageSize.width - imgWidth) / 2,
        10,
        imgWidth,
        imgHeight
      );

      doc.setFont("NotoSansArabic");
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0); // Couleur noire

      // Ajouter les textes d'en-tête
      
doc.text(
  `الأكاديمية الجهوية : ${directions.direction_regionale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 15, 
  { align: 'center' }
);

doc.text(
  `مديرية ${directions.direction_provinciale}`, 
  doc.internal.pageSize.width / 2, 
  imgHeight + 30, 
  { align: 'center' }
);
      doc.text(
        "  مصلحة تأطير المؤسسات التعليمية و التوجيه  ",
        doc.internal.pageSize.width / 2,
        imgHeight + 45,
        { align: "center" }
      );

      const pageWidth = doc.internal.pageSize.width;

      doc.setFontSize(10);
      doc.text(
        "  المؤسسة : " + selectedInstitution,
        pageWidth - 20,
        imgHeight + 60,
        { align: "right" }
      );

      doc.setFont("NotoSansArabic");
      doc.text(
        "  السنة الدراسية: " + selectedAnneeScolaire,
        80,
        imgHeight + 60,
        { align: "left" }
      );

      doc.text("- جدول  - أ", pageWidth / 2, imgHeight + 75, {
        align: "center",
      });
      const textWidth = doc.getTextWidth("- جدول  - أ");
      const textXPosition = pageWidth / 2 - textWidth / 2;

      doc.setLineWidth(2);
      doc.line(
        textXPosition,
        imgHeight + 80,
        textXPosition + textWidth,
        imgHeight + 80
      );

      doc.setFontSize(10);
const label = " : القسم ";  // note l’espace avant ':', pour espacer un peu
const y = imgHeight + 90;
const centerX = pageWidth /2 + 230;

// Calculer largeur de chaque partie
doc.setFont('NotoSans');
const classeWidth = doc.getTextWidth(classe);

doc.setFont('NotoSansArabic');
const labelWidth = doc.getTextWidth(label);

// Largeur totale = classe + label
const totalWidth = classeWidth + labelWidth;

// Point de départ (pour centrer l’ensemble)
const startX = centerX - totalWidth / 2;

// Écrire d’abord la classe en NotoSans
doc.setFont('NotoSans');
doc.text(classe, startX, y);

// Écrire ensuite le label à droite de la classe en NotoSansArabic
doc.setFont('NotoSansArabic');
doc.text(label, startX + classeWidth, y);



      // Colonnes du tableau
      const columns = [
        { header: "موسسة الاستقبال", dataKey: "reintegration" },
        { header: "قرار المجلس", dataKey: "decisionConseil" },
        { header: "المعدل السنوي", dataKey: "noteTotal" },
        {
          header: "اللغة الاجنبية الثانية ",
          dataKey: "deuxiemeLangueEtrangere",
        },
        { header: "الاولى", dataKey: "niveauActuel" },
        { header: "الثانية", dataKey: "un_an_avant" },
        { header: "الثالثة", dataKey: "deux_an_avant" },
        { header: "الاسم الكامل", dataKey: "fullName" },
        { header: "رقم مسار", dataKey: "numeroEleve" },
        { header: "الرقم الترتيبي", dataKey: "num" },
      ];

      // Préparer le body des lignes du tableau
      const body = students.map((row) => ({
    reintegration: hostInstitutionMap[row.classe] || "", // ← nouvelle logique ici
        decisionConseil: row.decisionConseil || "", // قرار المجلس
        noteTotal: row.noteTotal || "", // المعدل السنوي
        deuxiemeLangueEtrangere: row.deuxiemeLangueEtrangere || "", // اللغة الاجنبية الثانية
        niveauActuel: row.niveauActuel || "", // الاولى
        un_an_avant: row.un_an_avant || "", // الثانية
        deux_an_avant: row.deux_an_avant || "", // الثالثة
        fullName: row.fullName || row.nomEtPrenom || "", // الاسم الكامل
        numeroEleve: row.numeroEleve || row.massarId || "", // رقم مسار
        num: row.num || "", // الرقم الترتيبي
      }));

      // Générer le tableau avec autoTable
      doc.autoTable({
        startY: 180,
        head: [columns.map((col) => col.header)],
        body: body,
        columns: columns,
        styles: {
          font: "NotoSansArabic",
          halign: "right",
          fontSize: 7,
        },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: 0,
          halign: "center",
          fontStyle: "bold",
          fontSize: 7.2,
        },
        columnStyles: {
          0: { cellWidth: "auto" },
          1: { cellWidth: "auto" },
          2: { cellWidth: "auto" },
          3: { cellWidth: "auto" },
          4: { cellWidth: "auto" },
          5: { cellWidth: "auto" },
          6: { cellWidth: "auto" },
          7: { cellWidth: "auto" },
          8: { cellWidth: "auto" },
          9: { cellWidth: "auto" },
        },
        margin: { top: 180, right: 10, left: 10 },
        didDrawPage: function(data) {
          if (data.pageNumber === 1) {
            data.settings.margin.top = 21;
          } else {
            data.settings.margin.top = 10;
          }
          const lastRowIndex = data.cursor.index;
          if (lastRowIndex === 22) {
            data.settings.margin.top = 50;
          }
          
        },
        didParseCell: function(data) {
          if (data.section === "body" && data.column.dataKey === "massarId") {
            data.cell.styles.font = "NotoSans";
            data.cell.styles.fontStyle = "bold";
          }
          if (data.section === "body" && data.column.dataKey === 'numeroEleve') {
      data.cell.styles.font = 'NotoSans';
    }
        },
      });

      // Bas de page avec signature sur la dernière page seulement
      const totalPages = doc.internal.getNumberOfPages();

      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        doc.setPage(pageNumber);

        const pageHeight = doc.internal.pageSize.height;
        const footerYPosition = pageHeight - 50;

        if (pageNumber === totalPages) {
          doc.setFont("NotoSansArabic");
          doc.text(": توقيع رئيس المؤسسة ", 480, footerYPosition + 20);
        }
      }
    });

    // Enregistrer le PDF après avoir généré toutes les pages
    doc.save("- جدول  - أ.pdf");
  };

  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Centrage horizontal
          alignItems: "center",

          backgroundColor: "#F9F9F9",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          direction: "rtl",
          fontFamily: "Arial, sans-serif",
          fontSize: "22px",
          fontWeight: "bold",
          height: "80px",
          gap: "20px",
        }}
      >
        <span> جدول ( أ ) </span>
      </div>
      <br></br>

      <h5 className="title" style={{ textAlign: "right" }}>
        {" "}
        : ادخل السنة الدراسية{" "}
      </h5>

      <TextField
        fullWidth
        label="السنة الدراسية"
        value={selectedAnneeScolaire}
        onChange={(e) => setSelectedAnneeScolaire(e.target.value)}
        sx={{ marginBottom: "1rem", textAlign: "right", direction: "rtl" }}
      />

      <h5 className="title" style={{ textAlign: "right" }}>
        {" "}
        : اختر المؤسسة
      </h5>
      <select
        className="select"
        onChange={(e) => setSelectedInstitution(e.target.value)}
        value={selectedInstitution}
      >
        <option value="" style={{ textAlign: "right" }}>
          -- اختر --
        </option>
        {institutions &&
          institutions.length > 0 &&
          institutions.map((institution) => (
            <option
              style={{ textAlign: "right" }}
              key={institution}
              value={institution}
            >
              {institution}
            </option>
          ))}
      </select>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "1rem",
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => handleGoBack("PageLayout3V3")}
          sx={{
            borderRadius: "8px",
            borderColor: "#e74c3c", // Couleur de la bordure rouge
            color: "#e74c3c", // Couleur du texte
            padding: "8px 16px", // Ajustez les marges internes
            fontSize: "14px", // Ajustez la taille du texte
            "&:hover": {
              backgroundColor: "#f8d7da", // Couleur au survol
            },
          }}
          startIcon={<ArrowBackIcon />} // Ajoute l'icône au début du texte
        >
          رجوع
        </Button>
        <div className="form-group" style={{ textAlign: "center" }}>
          <button onClick={handleExportPDF} className="btn btn-secondary">
            PDF تصدير إلى
          </button>
        </div>
      </Box>
    </div>
  );
};

export default TableA;
